module.exports = __webpack_public_path__ + "img/Icon - Shopping Cart - Filled.19227c14.svg";